// extracted by mini-css-extract-plugin
export default {"chip":"TagChip_chip__uka1G","chipSm":"TagChip_chipSm__sVSF4","chipMd":"TagChip_chipMd__tZKlV","chipLg":"TagChip_chipLg__Ky46Z","chipIcon":"TagChip_chipIcon__goL9w"};